import React from "react";
import { Link } from "react-router-dom";

export default function PageHeader(){
    return(
        <>
              <div class="container-fluid page-header py-5 mb-5 wow fadeIn" data-wow-delay="0.1s">
        <div class="container text-center py-5">
            <h1 class="display-3 text-white mb-4 animated slideInDown">Contact Us</h1>
            <nav aria-label="breadcrumb animated slideInDown">
                <ol class="breadcrumb justify-content-center mb-0">
                    <li class="breadcrumb-item"><Link to="/#">Home</Link></li>
                    <li class="breadcrumb-item"><Link to="/#">Pages</Link></li>
                    <li class="breadcrumb-item active" aria-current="page">Contact</li>
                </ol>
            </nav>
        </div>
    </div>
        </>
    )
}